var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.title),expression:"title"}],class:_vm.classes,on:{"click":_vm.subscribe}},[(_vm.active)?_c('span',{staticClass:"font-weight-bold"},[_vm._v("😍 "+_vm._s(_vm.__("Subscribed")))]):_c('span',{staticClass:"blue font-weight-bold"},[_vm._v(_vm._s(_vm.__("Subscribe")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }